(function (Cobalt) {
    var BreakwidthNotifier = /** @class */ (function () {
        function BreakwidthNotifier() {
            this.breakWidthSubscribers = {};
            this.lastWidth = null;
            this.isInitialized = false;
            this.nextId = 0;
            this.breakWidthManager = this;
        }
        // ReSharper disable once InconsistentNaming
        BreakwidthNotifier.prototype.Subscribe = function (breakwidth, callback) {
            this.nextId++;
            // keep track of this subscriber
            this.breakWidthSubscribers[this.nextId] = {
                width: breakwidth,
                callback: callback
            };
            if (this.isInitialized) {
                return this.nextId; // we've already initialized
            }
            this.initializeResizeHandler();
            return this.nextId; // return the subscriber id
        };
        // ReSharper disable once InconsistentNaming
        BreakwidthNotifier.prototype.UnSubscribe = function (id) {
            delete this.breakWidthSubscribers[id];
        };
        BreakwidthNotifier.prototype.resize = function () {
            var currentWidth = window.outerWidth;
            for (var id in this.breakWidthManager.breakWidthSubscribers) {
                var subscriber = this.breakWidthManager.breakWidthSubscribers[id];
                if (this.breakWidthManager.lastWidth == null
                    || (this.breakWidthManager.lastWidth > subscriber.width && currentWidth <= subscriber.width) // we went from above to break to it or below
                    || (this.breakWidthManager.lastWidth <= subscriber.width && currentWidth > subscriber.width)) {
                    var location = currentWidth <= subscriber.width
                        ? BreakWidthLocation.BelowOrEqual
                        : BreakWidthLocation.Above;
                    subscriber.callback(location);
                }
            }
            this.lastWidth = currentWidth;
        };
        BreakwidthNotifier.prototype.initializeResizeHandler = function () {
            var _this = this;
            this.isInitialized = true;
            this.breakWidthManager = this;
            // ReSharper disable once UnusedLocals
            window.onresize = function (event) {
                clearTimeout(_this.resizeTimer);
                _this.resizeTimer = setTimeout(_this.resize, 1000);
            };
        };
        return BreakwidthNotifier;
    }());
    var ResponsiveUtility = /** @class */ (function () {
        function ResponsiveUtility() {
        }
        // ReSharper disable InconsistentNaming
        ResponsiveUtility.AbbreviateCounts = function (countContainerElementSelector, countDataAttributeName, abbreviatedCountDataAttributeName, mobileBreakWidth) {
            // ReSharper restore InconsistentNaming
            ///<summary>Enable a mobile-friendly view of an unordered list. Certain mark-up is required.</summary>
            ///<param name="countContainerElementSelector">The jQuery selector for the element that contains the count to shorten.</param>
            ///<param name="countDataAttributeName">The name of the data attribute that contains the original value.</param>
            ///<param name="abbreviatedCountDataAttributeName">The name of the data attribute that contains the abbreviated value.</param>
            ///<param name="mobileBreakWidth">When the window width hits this value, it will break into the mobile view</param>
            var _this = this;
            // get all jQuery objects from the selectors being passed in
            var $countItems = $(countContainerElementSelector);
            ResponsiveUtility.BreakwidthNotifier.Subscribe(mobileBreakWidth, function (location) {
                _this.handleCounts($countItems, countDataAttributeName, abbreviatedCountDataAttributeName, location);
            });
        };
        ResponsiveUtility.handleCounts = function ($countElements, countDataAttributeName, abbreviatedCountDataAttributeName, location) {
            var processElement = function (index, elem) {
                var $element = $(elem);
                if (location == BreakWidthLocation.Above) {
                    var aboveText = $element.data(countDataAttributeName);
                    if (aboveText) {
                        $element.text(aboveText);
                    }
                }
                else {
                    var belowText = $element.data(abbreviatedCountDataAttributeName);
                    if (belowText) {
                        $element.text(belowText);
                    }
                }
            };
            $countElements.each(processElement);
        };
        // ReSharper disable once InconsistentNaming
        ResponsiveUtility.BreakwidthNotifier = new BreakwidthNotifier();
        return ResponsiveUtility;
    }());
    Cobalt.ResponsiveUtility = ResponsiveUtility;
    var BreakWidthLocation;
    (function (BreakWidthLocation) {
        BreakWidthLocation[BreakWidthLocation["Above"] = 0] = "Above";
        BreakWidthLocation[BreakWidthLocation["BelowOrEqual"] = 1] = "BelowOrEqual";
    })(BreakWidthLocation = Cobalt.BreakWidthLocation || (Cobalt.BreakWidthLocation = {}));
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ResponsiveUtility.js